var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e(),_c('Indicator',{attrs:{"showIndicator":_vm.indicator.show,"indicatorText":_vm.indicator.text}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }